module.exports = __webpack_public_path__ + "static/media/HighAngelOfAether03.25173485.jpg";